import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalProps } from '@interfaces/Modal'
import FormParada from '../FormParada'
import Button from '@components/Common/Button'

const ModalParada: React.FC <ModalProps> = props => {

    return(

        <Modal title = "Parada" {...props}>
            <FormParada {...props} />
        </Modal>

    )

}

export default ModalParada